import { APP_ROUTES } from '@cpd-app/core-module/constants/routes';
import { SUMMARIZING_PARAGRAPH } from '@cpd-app/shared-module/constants';
export const CONFIG = {
  DIALOGS: {
    LEAVING_SITE: {
      WIDTH: '600px'
    }
  },
  INTERESTS_CHART: {
    COLORS: ['#DD5546', '#93A9D0', '#DB843D', '#89A54E', '#4298AF', '#A88CCC'],
    LABELS: [
      'REALISTIC',
      'INVESTIGATIVE',
      'ARTISTIC',
      'SOCIAL',
      'ENTERPRISING',
      'CONVENTIONAL'
    ]
  },
  INTERESTS_INFO: [
    {
      id: 1,
      name: 'realistic',
      blurb:
        'People who have athletic or mechanical abilities, those who prefer to work with their hands and things rather than people.',
      likes: [
        'Plants',
        'Build',
        'Machines',
        'Animals',
        'Outdoors',
        'Hands-On',
        'Things'
      ]
    },
    {
      id: 2,
      name: 'investigative',
      blurb:
        'People who like to observe, learn, investigate, or solve problems. Those who prefer working with ideas rather than people.',
      likes: [
        'Math',
        'Problem Solving',
        'Ideas',
        'Science',
        'Analyze',
        'Observe'
      ]
    },
    {
      id: 3,
      name: 'artistic',
      blurb:
        'People who have innovative or intuitional abilities and like to work in unstructured situations using their creativity or imagination.',
      likes: [
        'Music',
        'Drama',
        'Design',
        'Media',
        'Self-Expression',
        'Creative'
      ]
    },
    {
      id: 4,
      name: 'social',
      blurb:
        'People who like to work with people - to inform, enlighten, help, train, or cure them. Prefer solving problems through discussion.',
      likes: ['Communicate', 'People', 'Guide', 'Teach', 'Service', 'Help']
    },
    {
      id: 5,
      name: 'enterprising',
      blurb:
        'People who like to work with people - influencing, persuading or leading. They enjoy leadership positions and dislike details.',
      likes: [
        'Persuade',
        'Lead',
        'Risk-Taking',
        'Decisions',
        'Business',
        'Action'
      ]
    },
    {
      id: 6,
      name: 'conventional',
      blurb:
        'People who like to work with data, have numerical or clerical ability carrying things out in detail or following instruction.',
      likes: [
        'Procedures',
        'Standards',
        'Data',
        'Routines',
        'Detail',
        'Structure'
      ]
    }
  ],
  WORK_VALUES: {
    BUSINESS_RULES: {
      MAX_LEVEL: 7,
      MAX_CHECKED: 3,
      DEFAULT_LEVEL: 2,
      IGNORE_LEVEL: 0
    },
    MESSAGES: {
      TOO_MANY_SELECTIONS:
        'Please select your top 3 work values.  You may deselect a previous selection.'
    },
    LIST: [
      {
        workValueId: '1.B.2.a',
        workValueName: 'Achievement',
        blurb:
          'This line of work is results-oriented and allows employees to use their strongest abilities, giving them a feeling of accomplishment.',
        level: 0,
        isChecked: false,
        order: 0
      },
      {
        workValueId: '1.B.2.b',
        workValueName: 'Working Conditions',
        blurb:
          'This line of work offers job security and good working conditions.',
        level: 0,
        isChecked: false,
        order: 0
      },
      {
        workValueId: '1.B.2.c',
        workValueName: 'Recognition',
        blurb:
          'This line of work offers advancement and potential for leadership, and is often considered prestigious.',
        level: 0,
        isChecked: false,
        order: 0
      },
      {
        workValueId: '1.B.2.d',
        workValueName: 'Relationships',
        blurb:
          'This line of work allows employees to provide service to others and work with co-workers in a friendly, non-competitive environment.',
        level: 0,
        isChecked: false,
        order: 0
      },
      {
        workValueId: '1.B.2.e',
        workValueName: 'Support',
        blurb:
          'This line of work offers supportive management that stands behind employees.',
        level: 0,
        isChecked: false,
        order: 0
      },
      {
        workValueId: '1.B.2.f',
        workValueName: 'Independence',
        blurb:
          'This line of work allows employees to work on their own and make decisions.',
        level: 0,
        isChecked: false,
        order: 0
      }
    ]
  },
  MPC_LIST: [
    {
      id: 'E',
      name: 'Enlisted'
    },
    {
      id: 'O',
      name: 'Commission Officer'
    },
    {
      id: 'W',
      name: 'Warrant Officer'
    }
  ],
  MPC_TYPES: {
    ENLISTED: 'E',
    COMMISSION_OFFICER: 'O',
    WARRANT_OFFICER: 'W'
  },
  OCCUPATION: {
    MATCH_QUALITY: [
      { id: null, name: 'N/A' },
      { id: 0, name: 'Not Aligned', isStartingMatch: false },
      { id: 1, name: 'Poor', isStartingMatch: true },
      { id: 2, name: 'Fair', isStartingMatch: false },
      { id: 3, name: 'Good', isStartingMatch: false },
      { id: 4, name: 'Great', isStartingMatch: false },
      { id: 5, name: 'Excellent', isStartingMatch: false },
      { id: 6, name: 'Overqualified', isStartingMatch: false }
    ],
    OCCUPATION_CARD_WIDTH: 335,
    VIDEO: {
      URL: 'https://cdn.careeronestop.org/OccVids/OccupationVideos/{onetCode}.mp4',
      SUBTITLE_URL: 'https://cdn.careeronestop.org/CaptionFiles/{onetCode}.vtt'
    }
  },
  SETTINGS: {
    PAGINATION: {
      LENGTH: 1000,
      PAGE_SIZE: 25,
      PAGE_SIZE_OPTIONS: [5, 10, 25, 100]
    }
  },
  STATIC_CONTENT: {
    HOW_THIS_WORKS: {
      WORK_EXPERIENCE:
        'Your work experience is the fastest way for us to understand your likely skills, which makes it possible to match you with occupations that require them.',
      EDUCATION:
        'Knowing your academic achievements will further help us zero in on the jobs that that are a great match for you.',
      EDUCATION_GOAL:
        'Your academic goals help us understand what kind of education or training you’re aiming for. If you’re not sure yet, that’s okay — we’ll still show academic options that match careers your interested in.'
    },
    OCCUPATION_DETAIL: {
      GOTO_EXTERNAL_LINK_MESSAGE:
        'You’re about to leave this site to an external link. Are you sure you want to continue?'
    },
    RETURN_LINK: {
      TITLE: 'Save Your Return Link',
      INTRO:
        'We encourage you to keep your work so far so you can come back, add to it, and refine it. Email your return link to yourself or copy the link below and save it.',
      TITLE_SENT: 'Email Sent!',
      MESSAGE:
        'We’ve just emailed you your return link. Use it to return to your session, and keep it to yourself: it signs you in.'
    },
    GOALS_REPORT: {
      DOWNLOAD: {
        MESSAGE_FOR_AIRFORCE_AFTER_HAS_GOAL:
          'Take all 4 surveys and set a career goal to download goal report to review and compare results.',
        MESSAGE_AFTER_HAS_GOAL:
          'Take the skills survey and set a career goal to download goal report to review and compare results.',
        MESSAGE_FOR_AIRFORCE:
          'Take all 4 surveys and set a career goal to download the goal report to review and compare results.',
        MESSAGE:
          'Take the skills survey and set a career goal to download the goal report to review and compare results.'
      }
    },
    GOALS_REPORT_FILE_NAME: 'GoalReport.pdf',
    SUB_TITLES: {
      MILITARY_SKILLS:
        'Tell me about your work experience so I can gather your skills.',
      OTHER_SKILLS: 'Do you have civilian work experience as well?',
      EDUCATION:
        'Last but not least, what types of education, licensures, and certifications have you attained?',
      EDUCATION_GOALS_1:
        'Are there any academic programs you are interested in?',
      EDUCATION_GOALS_2:
        'Enter in your initial academic interest from the drop down below.',
      EDUCATION_SCHOOL_GOALS_1:  'Are there any schools, universities, or colleges you are interested in?',
      EDUCATION_SCHOOL_GOALS_2:
        'Enter in your initial school interest from the drop down below.'
    },
    WORK_VALUES: {
      SURVEY: {
        INTRO_MESSAGE:
          'Work environments can be divided into the six broad value areas.  These can be combined in many different ways.  Knowing your unique combination of values can assist you in determining jobs that suit you best.  Choose the three value areas that are most important for you to have at a job.'
      },
      SURVEY_SORTING: {
        INTRO_MESSAGE:
          'Arrange the three selected areas by order of importance.'
      }
    },
    TUTORIAL_VIDEO: {
      TAKE_SURVEYS: {
        title: 'Take Your Surveys',
        videoUrl:
          'https://careerpathdecide-media.s3.us-east-2.amazonaws.com/video/Surveys+-+Step+1.mp4',
        videoSubtitleUrl: '/assets/vtt/take_surveys.vtt'
      },
      SET_CAREER_GOAL: {
        title: 'Set Your Career Goal',
        videoUrl:
          'https://careerpathdecide-media.s3.us-east-2.amazonaws.com/video/Career+Goal+-+Step+2.mp4',
        videoSubtitleUrl: '/assets/vtt/set_goal.vtt'
      },
      SET_ACADEMIC_GOAL: {
        title: 'Set Your Academic Goal',
        videoUrl:
          'https://careerpathdecide-media.s3.us-east-2.amazonaws.com/video/Set+Academic+Goal+-+Step+3.mp4',
        videoSubtitleUrl: '/assets/vtt/set_academic.vtt'
      },
      SAVE_RETURN_LINK: {
        title: 'Save Your Return Link',
        videoUrl:
          'https://careerpathdecide-media.s3.us-east-2.amazonaws.com/video/Goal+Report+-+Step+4.mp4',
        videoSubtitleUrl: '/assets/vtt/download_report.vtt'
      }
    }
  },
  WHITELIST: {
    ALLOWED_DOMAINS: [
      'localhost:4200',
      'dev.careerpathdecide.org',
      'gov',
      'mil'
    ]
  },
  OUT_OF_US_LOCATION: {
    name: 'I live out of the U.S.',
    fipsCode: null,
    lat: null,
    lon: null
  },
  WEBSITES: [
    {
      link: 'https://open.defense.gov/Transparency/FOIA.aspx',
      label: 'FOIA'
    },
    {
      link: 'https://www.defense.gov//Resources/DOD-Information-Quality-Guidelines',
      label: 'Information Quality'
    },
    {
      link: 'https://prhome.defense.gov/NoFear',
      label: 'No Fear Act'
    },
    {
      link: 'https://www.esd.whs.mil/DD/plainlanguage',
      label: 'Plain Writing'
    },
    {
      link: 'http://defense.gov/privacy',
      label: 'Privacy Program'
    },
    {
      link: 'https://dam.defense.gov/Performance',
      label: 'Strategic Management Plan'
    },
    {
      link: 'https://open.defense.gov',
      label: 'Open Government'
    },
    {
      link: 'https://dodcio.defense.gov/DoDSection508/Std_Stmt.aspx',
      label: 'Section 508'
    },
    {
      link: 'http://usa.gov',
      label: 'USA.gov'
    }
  ],
  DOD_LINK:
    'https://dpcld.defense.gov/Portals/49/Documents/Privacy/SORNs/OSDJS/DoD-0005.pdf',
  FOOTER_LINKS: [
    // {
    //   path: APP_ROUTES.About.Resources,
    //   label: 'Resources'
    // },
    {
      path: APP_ROUTES.About.PrivacyPolicy,
      label: 'Privacy Policy',
      showCookie: true
    },
    {
      path: APP_ROUTES.About.TermsOfUse,
      label: 'Terms of Use'
    },
    {
      path: APP_ROUTES.About.DataSources,
      label: 'Data Sources'
    },
    // {
    //   path: APP_ROUTES.About.Base,
    //   label: 'About Us'
    // },
    {
      path: APP_ROUTES.About.News,
      label: 'News'
    },
    {
      path: APP_ROUTES.Manager.Base,
      label: 'Administration'
    },
    {
      path: APP_ROUTES.Analytics,
      label: 'Analytics'
    },
    {
      path: APP_ROUTES.About.SystemStatus,
      label: 'System Status'
    },
    // WCAG 2.4.5 (Multiple Ways): the site map, on every page.
    {
      path: APP_ROUTES.About.SiteMap,
      label: 'Site map'
    }
  ],
  // Consumed only by the Our Supporters page, which was removed in Aug 2026.
  // Kept rather than deleted: these are brand assets, and holding them makes
  // restoring the page a small job if that decision changes.
  SPONSORS: {
    SUPPORTERS: [
      {
        url: 'https://schultzfamilyfoundation.org',
        label: 'Schultz Family Foundation',
        logo: '/supporters/sff.svg'
      },
      {
        url: 'https://tullmanfamilyoffice.org',
        label: 'Tullman Family Office',
        logo: '/supporters/tullman-family-office.svg'
      },
      {
        url: 'https://www.walmart.com',
        label: 'Walmart',
        logo: '/supporters/walmart.svg'
      }
    ],
    PARTNERS: [
      {
        label: 'American Council on Education',
        url: 'https://www.acenet.edu',
        logo: '/partners/ace.svg'
      },
      {
        label: 'Student Veterans of America',
        url: 'https://studentveterans.org',
        logo: '/partners/sva.svg'
      }
    ]
  },
  PASSCODE: '123456',
  SUPPORT_EMAIL: 'supportcpd@vantagepoint-inc.com',
  INFO_EMAIL: 'info@vantagepoint-inc.com',
  PRIVACY_EMAIL: 'privacy@vantagepoint-inc.com',
  VP_CPD_INFO: 'https://www.vantagepoint-inc.com/products/career-path-decide',
  CHAT_VIA: {
    WIDTH: 415,
    SIDEBAR_COLLAPSED_WIDTH: 55,
    SIDEBAR_EXPANDED_WIDTH: 285
  },
  SUMMARIZING_PARAGRAPH
};
